import Header1 from "./components/Headers/Header1"
import Header2 from "./components/Headers/Header2"
import Body1 from "./components/Bodies/Body1"
import Body2 from "./components/Bodies/Body2"
import Body3 from "./components/Bodies/Body3"
import Button1 from "./components/Buttons/Button1"
import Button2 from "./components/Buttons/Button2"
import Subtitle from "./components/Other/Subtitle"
import Figure from "./components/Other/Figure"
import Link from "./components/Other/Link"
import RefLink from "./components/Other/RefLink"
import Reference from "./components/Other/Reference"

export { TextColor, TextWeight } from "./types/textTypes"

const Texts = {
  Header1,
  Header2,
  Subtitle,
  Body1,
  Body2,
  Body3,
  Button1,
  Button2,
  Figure,
  Link,
  RefLink,
  Reference,
}

export default Texts
